import { render, staticRenderFns } from "./dialogShow.vue?vue&type=template&id=4a6d1070&"
import script from "./dialogShow.vue?vue&type=script&lang=js&"
export * from "./dialogShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports